'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentQiwiAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "#F28A1A",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M49.768 36.9978C50.1463 36.9978 50.6193 37.1869 51.0922 37.5653C51.8489 38.2274 52.1327 38.9841 51.7543 39.5516C51.5652 39.8354 51.0922 40.0245 50.7139 40.0245C50.2409 40.0245 49.768 39.8354 49.4842 39.5516C48.7275 38.8895 48.5384 37.9436 49.0113 37.3761C49.1059 37.1869 49.3897 36.9978 49.768 36.9978Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M53.646 34.0656C54.3081 34.3493 54.5919 35.2952 54.5919 35.7681C54.6865 36.5248 54.4973 36.9032 54.2136 36.9032C53.9298 36.9032 53.5515 36.6194 53.1731 35.9573C52.7948 35.2952 52.6056 34.6331 52.7948 34.2547C53.0785 34.0656 53.3623 33.971 53.646 34.0656Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M40.7823 44.4701C30.9453 44.4701 23 36.5248 23 26.7823C23 17.0399 30.9453 9 40.7823 9C50.6194 9 58.5647 16.9453 58.5647 26.7823C58.5647 30.0929 57.6188 33.2143 56.1054 35.8627C56.0108 35.9573 55.9163 35.9573 55.9163 35.7681C55.2541 31.4171 52.6057 29.0524 48.8222 28.2957C48.4439 28.2011 48.4439 28.012 48.9168 28.012C50.1465 27.9174 51.7544 27.9174 52.7003 28.1066C52.7949 27.6336 52.7949 27.1607 52.7949 26.7823C52.7949 20.3504 47.498 15.0536 41.0661 15.0536C34.6342 15.0536 29.3373 20.3504 29.3373 26.7823C29.3373 33.2143 34.6342 38.5111 41.0661 38.5111H41.6336C41.4445 37.4707 41.3499 36.4302 41.4445 35.2952C41.4445 34.5385 41.6336 34.4439 41.9174 35.0114C43.5254 37.849 45.89 40.3083 50.4302 41.3487C54.1191 42.2 57.808 43.1459 61.8752 48.159C62.2536 48.6319 61.6861 49.1049 61.3077 48.7265C57.2405 45.1322 53.5516 43.9026 50.1465 43.9026C45.89 43.9972 43.3362 44.4701 40.7823 44.4701Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpPaymentQiwiAsset = forwardRef(PaymentQiwiAsset);

export { VpPaymentQiwiAsset as default };
